module.exports = __webpack_public_path__ + "static/media/glittek-granites.ca5b67e4.png";